S<template>
  <div class="addedit-lead center">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-1/2 justify-right">
        <h2
          class="pl-2"
        >{{ editRoute ? $t('labels.edit_section_subsection') : $t('labels.add_section_subsection') }}</h2>
      </div>
    </div>
    <form @submit.prevent="checkValidation()" autocomplete="off">
      <vx-card class="addedit-lead-card">
        <!-- Section -->
        <div class="vx-row w-full m-0">
          <div class="vx-col sm: w-full md:w-1/2 mb-4 pl-0">
            <label>{{$t('labels.name')}}</label>
            <vs-input
              type="text"
              class="w-full mt-1"
              name="section_name"
              maxlength="250"
              v-model="name"
              icon-no-border
              :placeholder="$t('labels.name')"
              v-validate="'required'"
            />
            <span class="text-danger text-sm">{{ errors.first('section_name') }}</span>
          </div>
<!--          <div class="vx-col sm: w-full md:w-1/2 mb-4 pl-0">-->
<!--            <label>{{$t('labels.section_number')}}</label>-->
<!--            <vs-input-->
<!--              type="text"-->
<!--              class="w-full mt-1"-->
<!--              name="number"-->
<!--              maxlength="3"-->
<!--              v-model="number"-->
<!--              icon-no-border-->
<!--              :placeholder="$t('labels.number')"-->
<!--              v-validate="'required|numeric'"-->
<!--            />-->
<!--            <span class="text-danger text-sm">{{ errors.first('number') }}</span>-->
<!--          </div>-->
          <div class="vx-col sm: w-full md:w-1/2 mb-4 pl-0">
            <label>{{ $t('labels.parent_section')}}</label>
            <v-select
              v-model="parent_id"
              :options="parentSection"
              :reduce="parentSection => parentSection.id"
              label="name"
              class="w-full mt-1"
            />
          </div>
        </div>
        <div class="mt-2 btn-lead flex justify-center">
          <vs-button
            class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
            :disabled="button_loading"
            id="create-section"
            button="submit"
          >{{ editRoute ? $t('labels.update_section_subsection') : $t('labels.add_section_subsection') }}</vs-button>
        </div>
      </vx-card>
    </form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: null,
      subsection: null,
      number: null,
      parent_id: null,
      parentSection: [],
      numbers: []
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.setValidationMessage();
    this.getSections();
    if (this.editRoute) {
      this.getSection();
    }
  },
  methods: {
    // API Integration for get Parent sections
    async getSections() {
      let input = {
        only_parents: true
      };
      let response = await this.getHTTPPostResponse("/sections/list", input);
      if (response) {
        let sections = response.data.sections;
        let _this = this;
        let filteredSections = [];
        for (var i = 0; i < sections.length; i++) {
          if (sections[i].id != _this.editRoute) {
            let obj = { id: sections[i].id, name: sections[i].name };
            filteredSections.push(obj);
          }
        }
        this.parentSection = filteredSections;
      }
    },

    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateSection();
        }
      });
    },
    // API Integration for add-update section
    async createUpdateSection() {
      let input = {
        name: this.name,
        parent_id: this.parent_id,
        number: 0
      };
      let url = this.editRoute
        ? "/sections/update/" + this.editRoute
        : "/sections/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-section",
        true
      );
      if (response) {
        this.$router.push({ name: "Sections" });
      }
    },
    // API Integration for get Sections
    async getSection() {
      let response = await this.getHTTPGetResponse(
        "/sections/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let section = data.section;
        this.name = section.name;
        //this.number = section.number;
        this.parent_id = section.parent_id > 0 ? section.parent_id : null;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>
